export const tokenInitiateLoading = state => {
  return [ state.dashboard.initiate, state.utils.loading];
};
export const initiateTotalRowMappingList = state => {
  return [state.dashboard.initiate, state.dashboard.totalRow, state.dashboard.mappingList];
};
